import styled from 'styled-components';

const BackgroundImageContainer = styled.div`
  .styles-container,
  .website-image,
  .gatsby-image-wrapper,
  img {
    position: absolute !important;
    top: 0;
    left: 0;
    height: 100% !important;
    width: 100% !important;
    object-fit: ${({ objectFit }) => objectFit || 'cover'} !important;
    ${({ gatsbyImage }) => (gatsbyImage ? 'z-index: -1' : 'z-index: 0')};
  }
`;

export { BackgroundImageContainer };
